import React from 'react'
import { AppRetailerBlockContainer } from "@components/DataBlocks"


export default function sitesNotAvailabilityColumn() {

	return [{
		name: "mainSiteFilter",
		label: 'Sites not available',
		options: {
			display: 'excluded'
		}
	}, {
		name: "mainSiteName",
		label: "Sites no availability",
		headerAlign: "left",
		options: {
			filter: false, customBodyRowRenderLite: value => <AppRetailerBlockContainer rows={value}/>
		}
	}]

}